/* Couleurs sémantiques d'un score /100, exprimées dans le nuancier de la
 * charte (kaki → jaune → terracotta → brique). Les échelles emerald/yellow/
 * orange/red sont remappées dans client/index.css : on garde donc les noms
 * Tailwind, ce sont les valeurs qui ont changé.
 *
 * `scoreColor` : couleur de texte (tons foncés, lisibles sur crème ; variante
 * claire en mode sombre). `scoreBg` : couleur de tracé SVG (tons saturés). */

export function scoreColor(score: number): string {
  if (score >= 80) return 'text-emerald-600';
  if (score >= 60) return 'text-yellow-700';
  if (score >= 40) return 'text-orange-600';
  return 'text-red-600';
}

export function scoreBg(score: number): string {
  if (score >= 80) return 'stroke-emerald-400';
  if (score >= 60) return 'stroke-yellow-400';
  if (score >= 40) return 'stroke-orange-400';
  return 'stroke-red-400';
}
